import { Flex, type MenuProps, Modal } from 'antd';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCurrentUser } from 'src/lib/customHooks/useCurrentUser';
import { useIsAdmin } from 'src/lib/customHooks/useIsAdmin';
import { useIsChildAccount } from 'src/lib/customHooks/useIsChildAccount';
import { UpdateStream } from '../AnnounceKit';
import { CostCalculator } from '../CostCalculator/index';
import { UserRoleBadges } from './UserRoleBadges';

export const useUserMenuItems = () => {
  const currentUser = useCurrentUser();
  const isChild = useIsChildAccount();
  const isAdmin = useIsAdmin();
  const [costCalcOpen, setCostCalcOpen] = useState(false);

  if (currentUser == null) {
    return { groupItems: [], dropdownItems: [], costCalcModal: null };
  }

  const userItems: NonNullable<MenuProps['items']> = [
    {
      key: 'account',
      label: <Link to={`/admin/account/${currentUser.id}`}>Account</Link>,
    },
    ...(isChild
      ? []
      : [
          { key: 'cost', label: 'Cost Calculator', onClick: () => setCostCalcOpen(true) },
          {
            key: 'billing',
            label: <Link to={`/admin/account/${currentUser.id}/billing`}>Billing</Link>,
          },
        ]),
    { key: 'updates', label: <UpdateStream>Updates</UpdateStream> },
    {
      key: 'logout',
      label: (
        <Link to="/auth/logout" id="nav_link_logout">
          Logout
        </Link>
      ),
    },
  ];

  const groupItems: NonNullable<MenuProps['items']> = [
    {
      key: 'user',
      label: (
        <Flex justify="space-between" align="center" gap={8}>
          <span>User</span>
          <UserRoleBadges />
        </Flex>
      ),
      children: userItems,
    },
  ];

  const costCalcModal = isChild ? null : (
    <Modal
      title="Estimate costs for geolocating"
      open={costCalcOpen}
      onCancel={() => setCostCalcOpen(false)}
      footer={null}
      width={800}
    >
      <CostCalculator user={currentUser} isAdmin={isAdmin} />
    </Modal>
  );

  return { groupItems, dropdownItems: userItems, costCalcModal };
};
